import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { Redirect } from 'react-router';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { fromEvent } from 'file-selector';
import queryString from 'query-string';



import { isLoggedIn } from 'utils';
import { FILE_UPLOAD } from 'constants/ActionTypes';

export default (WrappedComponent) => {
  class withDropzone extends React.Component {
    state = {
      hover: false,
    };

    getPrefix = () => this.props.location.search ? queryString.parse(this.props.location.search).prefix : '';

    onDrop = (files) => {
      this.setState({ hover: false });

      this.props.dispatch({
        type: FILE_UPLOAD,
        files,
        prefix: this.getPrefix()
      });
    };

    onDragEnter = () => {
      this.setState({ hover: true });
    };

    onDragLeave = () => {
      this.setState({ hover: false });
    };

    render() {
      return (
        <Dropzone
          disableClick
          getDataTransferItems={evt => fromEvent(evt)}
          onDrop={this.onDrop}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
          style={{
            height: '100%'
          }}
        >
          <WrappedComponent {...this.props} />
          {this.state.hover &&
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h4>Drop file here</h4>
          </div>
          }
        </Dropzone>
      );
    }
  }

  hoistNonReactStatic(withDropzone, WrappedComponent);

  return connect()(withDropzone);
}